<script>
    import NormalArticle from '@/components/widgets/NormalArticle.vue';
    import NormalQuestionWrap from '@/components/widgets/NormalQuestionWrap.vue';
    import NormalCommentArea from '@/components/widgets/NormalCommentArea.vue';

    export default {
        name: 'PageAnswer',
        data () {
            return {
                questionData: window._CONFIG.question_data,
                siteInfo: window._CONFIG.siteInfo,
                iframe: window._CONFIG.iframe,
            };
        },
        computed: {
            article () {
                return this.questionData.article;
            },
            form () {
                return this.questionData.form;
            },
            preferences () {
                return this.questionData.preferences;
            },
            displayRules () {
                return this.questionData.display_rules || [];
            },
            answerTitle () {
                return this.article ? this.article.title : this.form[0].title;
            },
            compType () {
                return this.preferences.comment_area ? 'comment_area' : (
                    this.article ? 'article' : 'question'
                );
            },
            feedback () {
                return this.questionData.feedback;
            },
            feedback_at () {
                return this.questionData.feedback_at;
            },
            statusChecked () {
                const {status} = this.questionData;
                return status === 'unpublished' || status === 'draft';
            }
        },
        methods: {
            getLimitText () {
                const {status} = this.questionData;
                if (status !== 'collecting') {
                    this.$modal.alert({
                        text: '当前问卷调查或意见征集' + this.$config.statusMap[status]
                    });
                } else {
                    setTimeout(() => {
                        this.fetchPv();
                    }, 2000);
                }
            },
            async fetchPv () {
                const url = this.$util.url(
                    `api/statistics/${ window._CONFIG.question_data.id }`,
                    'pv'
                );
                try {
                    await this.$api(url, {});
                } finally {
                    this.$bus.$emit('start:captcha');
                }

            }
        },
        mounted () {
            this.getLimitText();

            this.$bus.$on('cancel:focus', () => {
                const allIpt = document.querySelectorAll('input,select,textarea');
                Array.from(allIpt).forEach(el => {
                    el.blur();
                });
            });

            this.$util.setIframeHeight();
        },
        components: {
            NormalArticle,
            NormalCommentArea,
            NormalQuestionWrap
        }
    };
</script>
<template>
    <div class="answer-page" v-if="!statusChecked">
        <h1 class="answer-title" v-if="!iframe">{{ answerTitle }}</h1>
        <normal-article v-if="article"
                        :data="article"
                        :feedbackAt="feedback_at"
                        :feedback="feedback"/>
        <normal-question-wrap :type="compType"
                              :withArticle="!!article"
                              :status="questionData.status"
                              :preferences="preferences"
                              :displayRules="displayRules"
                              :data="form"/>
        <normal-comment-area v-if="preferences.comment_area"
                             :site-name="siteInfo.org_name"/>
    </div>
</template>
<style scoped lang="less">
    @import "../../../../southcn-mobile-ui/src/assets/less/widgets-var";

    .answer-page {
        .px2rem(padding-top, 60);
        .px2rem(padding-bottom, 60);
        .px2rem(padding-left, 35);
        .px2rem(padding-right, 35);
    }

    .answer-title {
        text-align: center;
        word-break: break-all;
        .px2rem(padding-bottom, 50);
        .px2rem(font-size, 36);
    }
</style>
